export default {

  init() {
    const $toggleItems = document.querySelectorAll('.js-toggle');
    $toggleItems.forEach($item => {
      const $target = document.querySelector('#' + $item.getAttribute('aria-controls'));
      if (!$target) {
        // eslint-disable-next-line
        console.error('Could not find target for Toggle element', $item);
        return;
      }
      $item.addEventListener('click', (event) => {
        this.toggle(event, $target);
      });
    })
  },

  /**
   * Toggle the toggler
   */
  toggle(event, $target) {
    event.preventDefault();
    if (event.target.getAttribute('aria-expanded') === 'true') {
      this.collapse(event.target, $target);
    } else {
      this.expand(event.target, $target);
    }
  },

  expand($element, $target) {
    $element.classList.add('has-expanded-content');
    $element.setAttribute('aria-expanded', 'true');
    $target.classList.remove('u-hide');

  },

  collapse($element, $target) {
    $element.classList.remove('has-expanded-content');
    $element.setAttribute('aria-expanded', 'false');
    $target.classList.add('u-hide');
  },
}
